{
  "actions": {
    "add": "Add",
    "create": "Create",
    "delete": "Delete",
    "remove": "Remove",
    "confirm": "Confirm",
    "deny": "Deny",
    "bill": "Bill"
  },
  "status": {
    "draft": "Draft",
    "published": "Published",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "participant": {
      "interested": "Interested",
      "confirmed": "Confirmed",
      "denied": "Denied"
    }
  },
  "tabs": {
    "overview": "Overview",
    "details": "Details",
    "participants": "Participants ({count})",
    "fees": "Fees ({count})",
    "expenses": "Expenses",
    "revenue": "Revenue",
    "gallery": "Gallery",
    "todos": "Todos",
    "notes": "Notes",
    "files": "Files"
  },
  "list": {
    "title": "Events",
    "add": "Add Event",
    "filterAll": "All",
    "col": {
      "event": "Event",
      "type": "Type",
      "dates": "Dates",
      "going": "Going",
      "status": "Status"
    },
    "empty": {
      "heading": "No events yet",
      "message": "Create your first event to manage participants, finances, and todos."
    }
  },
  "form": {
    "addHeading": "Add Event",
    "editHeading": "Edit event",
    "defaultHeading": "Event",
    "name": "Name",
    "type": "Type",
    "typePlaceholder": "Type…",
    "status": "Status",
    "startDate": "Start date",
    "endDate": "End date",
    "capacity": "Capacity (blank = unlimited)",
    "shortDescription": "Short description",
    "visibility": "Visibility",
    "visibilityAll": "All students",
    "visibilityTags": "Only students with selected tags",
    "tagWarning": "Select at least one tag, or this event will be visible to no one.",
    "noTags": "No tags exist yet — create tags on the Students page first.",
    "detailsNotePre": "The details document students read before registering is edited in the event’s ",
    "detailsNotePost": " tab."
  },
  "detail": {
    "back": "Events",
    "editDetails": "Edit details",
    "noType": "No type",
    "unlimited": "Unlimited",
    "field": {
      "capacity": "Capacity",
      "confirmed": "Confirmed",
      "feeOptions": "Fee options",
      "status": "Status",
      "visibility": "Visibility"
    },
    "financialSummary": "Financial summary",
    "revenueCur": "Revenue ({currency})",
    "expenses": "Expenses",
    "net": "Net",
    "noFinancials": "No revenue or expenses recorded yet.",
    "description": "Description",
    "detailsDocument": "Details document",
    "allStudents": "All students",
    "tagsNoneHidden": "Tags (none — hidden)",
    "addStudentPlaceholder": "Add a student…",
    "feeFallback": "Fee",
    "billed": "billed",
    "wants": "wants: {name}",
    "readAgreed": "read & agreed",
    "feePlaceholder": "Fee…",
    "participantsEmpty": {
      "heading": "No participants yet",
      "message": "Students who register interest appear here, or add them directly."
    },
    "feesIntro": "Fee options for this event (e.g. Single, 2 persons, Family). Confirm a participant, then bill whichever option applies from the Participants tab.",
    "feeName": "Name",
    "feeNamePlaceholder": "e.g. 2 persons",
    "amount": "Amount",
    "feesEmpty": {
      "heading": "No fee options",
      "message": "Add at least one fee option to bill participants."
    },
    "dateLabel": "Date",
    "expensesEmpty": {
      "heading": "No expenses",
      "message": "Each expense is also booked to the accounting ledger."
    },
    "fromParticipantFee": "from participant fee",
    "revenueEmpty": {
      "heading": "No revenue",
      "message": "Add manual revenue (tickets, sponsorships). Each entry is booked to the ledger."
    }
  },
  "detailsDoc": {
    "importMd": "Import .md file",
    "save": "Save details",
    "hint": "Students read and accept this before registering interest. Write it here, or import a Markdown file.",
    "placeholder": "Write the event details students will read…",
    "empty": {
      "heading": "No details",
      "message": "No details document for this event yet."
    }
  },
  "notes": {
    "all": "All ({count})",
    "unfiled": "Unfiled",
    "folderFallback": "Folder",
    "newFolder": "New folder",
    "newNote": "New note",
    "editNote": "Edit note",
    "titleLabel": "Title",
    "folderLabel": "Folder",
    "createFolderTitle": "Create a new folder",
    "contentLabel": "Content",
    "loadFile": "Load from file",
    "loadFileTitle": "Load a Markdown or text file into this note",
    "editNoteTitle": "Edit note",
    "deleteNoteTitle": "Delete note",
    "deleteFolderTitle": "Delete folder",
    "saveNote": "Save note",
    "folderName": "Folder name",
    "createFolder": "Create folder",
    "deleteFolder": {
      "heading": "Delete folder",
      "message": "Delete folder \"{name}\"? Its notes are kept and become Unfiled.",
      "confirm": "Delete folder"
    },
    "deleteNote": {
      "heading": "Delete note",
      "message": "Delete note \"{name}\"? This can't be undone.",
      "confirm": "Delete note"
    },
    "empty": {
      "heading": "No notes",
      "manage": "Add planning notes, run sheets, or contacts for this event."
    }
  },
  "todos": {
    "live": "Live — changes sync in real time",
    "offline": "Offline — reconnecting…",
    "addPlaceholder": "Add a task…",
    "addSubtaskPlaceholder": "Add a sub-task…",
    "dragReorder": "Drag to reorder",
    "unassigned": "Unassigned",
    "assignee": "Assignee",
    "dueDate": "Due date",
    "addSubtask": "Add sub-task",
    "due": "due {date}",
    "confirmDelete": "Delete this item?",
    "confirmDeleteWithChildren": "Delete this item and all its sub-items?",
    "empty": {
      "heading": "No tasks yet",
      "manage": "Add the first task to start planning this event."
    }
  },
  "files": {
    "uploading": "Uploading…",
    "dropPrompt": "Drop a file here or click to upload",
    "hint": "PDF, images, Office docs, text, CSV or ZIP · up to 25 MB",
    "download": "Download",
    "confirmDelete": "Delete \"{name}\"?",
    "empty": {
      "heading": "No files",
      "manage": "Upload schedules, music, or any documents for this event."
    }
  },
  "gallery": {
    "newAlbum": "New album",
    "editAlbum": "Edit album",
    "albumName": "Album name",
    "descriptionOptional": "Description (optional)",
    "saveAlbum": "Save album",
    "allAlbums": "All albums",
    "pending": "{count} pending",
    "itemCountOne": "{count} item",
    "itemCountOther": "{count} items",
    "empty": {
      "heading": "No albums yet",
      "edit": "Create an album to collect this event’s photos and videos.",
      "view": "No photos or videos for this event yet."
    }
  },
  "toast": {
    "eventNameRequired": "Event name is required",
    "eventCreated": "Event created",
    "failed": "Failed",
    "eventUpdated": "Event updated",
    "addFeeFirst": "Add a fee option first (Fees tab)",
    "feeAddedToStudent": "Fee added to student account",
    "feeFieldsRequired": "Name, amount, and currency are required",
    "feeOptionAdded": "Fee option added",
    "entryFieldsRequired": "Description, amount, and currency are required",
    "expenseAdded": "Expense added",
    "revenueAdded": "Revenue added",
    "detailsTooLarge": "Details document is too large (max 256 KB)",
    "fileReadError": "Could not read that file",
    "detailsSaved": "Details saved",
    "folderNameRequired": "Folder name is required",
    "folderCreated": "Folder created",
    "titleRequired": "Title is required",
    "noteSaved": "Note saved",
    "importTypeError": "Only Markdown (.md) or text (.txt) files can be imported",
    "importTooLarge": "File too large (max 1 MB of text)",
    "fileLoadedIntoNote": "File loaded into note",
    "couldNotReadFile": "Could not read file",
    "fileTooLarge": "File too large (max 25 MB)",
    "fileUploaded": "File uploaded",
    "uploadFailed": "Upload failed",
    "albumNameRequired": "Album name is required",
    "albumSaved": "Album saved"
  }
}
